import React from 'react';
import { Link, useParams } from 'react-router-dom';

const SessionDetailPage = () => {
  const { sessionId } = useParams();

  return (
    <div className="step-container" style={{ padding: 16 }}>
      <div style={{ textAlign: 'left', marginBottom: 12 }}>
        <Link to="/scheduler" className="btn btn-secondary btn-small">캘린더로</Link>
      </div>
      <div style={{ padding: 24, color: '#666' }}>
        <p>세션 상세 API가 현재 구성되지 않았습니다.</p>
        <p style={{ marginTop: 8, fontSize: 14 }}>sessionId: {sessionId}</p>
      </div>
    </div>
  );
};

export default SessionDetailPage;
